import React from 'react';
import {Box, Button, ButtonGroup, Divider, Grid, ListItem} from "@mui/material";
import Typography from "@mui/material/Typography";
import {getRoomTotal} from "../../../utils/utils";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    spaces: {
        display: 'flex',
        justifyContent: 'center'
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
});

const RoomBox = ({room, selectedSpaces}) => {
    const prefix = window['siteUrl'];
    const spaces = selectedSpaces.length;

    const roomTotal = getRoomTotal(room, selectedSpaces);

        // selectedSpaces.reduce((acc, curr) => curr.singleOccupancy ? acc + room.price.single : acc + room.price.pretax, 0);

    const classes = useStyles();

    return (
        <>
            <Box component="div" display={{ xs: 'block', sm: 'block' }}>
                <ListItem alignItems={"flex-start"} style={{padding:0, margin:0}}>
                    <Grid container direction="row" spacing={3} alignItems={"center"} justify={"center"}>
                        <Grid item sm={4} xs={12}>
                            <img src={room['images'][0]} alt="Room1" width={'100%'} className={'roomImage'}/>
                        </Grid>
                        <Grid item sm={3} xs={5}>
                            <Typography variant="h4" component="h4" align="center" >
                                {/<\/?[a-z][\s\S]*>/i.test(room['title']) ?<span dangerouslySetInnerHTML={{__html: room['title']}}/>:room['title']}
                            </Typography>
                        </Grid>
                        <Grid item sm={2} xs={3}>
                            <div className={classes.spaces}>
                                <ButtonGroup size="small" aria-label="small outlined button group" className={'numBerths mini'}>
                                    <Button color="default" style={{width: 'auto'}} disabled>{spaces}</Button>
                                </ButtonGroup>
                            </div>
                        </Grid>
                        <Grid item sm={3} xs={4}>
                            <Typography variant="h4" component="h4" align="center">
                                <strong>${roomTotal.formatMoney(2)}</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
                <Divider variant="middle" className={'dividerFullWidth'} />
            </Box>
            
            <Box component="div" display={{ xs: 'none', sm: 'none' }}>
                <ListItem alignItems={"flex-start"}>
                    <Grid container direction="row" spacing={3} justifyContent={"space-around"}>
                        <Grid item sm={3}>
                            <Typography variant="h5" component="h5" align="center">
                                {/<\/?[a-z][\s\S]*>/i.test(room['title']) ?<span dangerouslySetInnerHTML={{__html: room['title']}}/>:room['title']}
                            </Typography>
                        </Grid>
                        <Grid item sm={3} >
                            <ButtonGroup size="small" aria-label="small outlined button group" className={'numBerths mini'}>
                                <Button color="default" disabled>{spaces}</Button>
                            </ButtonGroup>
                        </Grid>
                        <Grid item sm={3}>
                            <Typography variant="h5" component="h5" align="center">
                                {roomTotal}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
                <Divider variant="middle" className={'dividerFullWidth'} />
            </Box>
        </>
    );
};

export default RoomBox;
